import Logo from "../imgs/Logo_Hari_eigen.jpg"
import {ReadMoreButton} from "../UI/Buttons";
import "../css/article.scss"
import {useArticle} from "../sanity/useArticle"
import PT from "../sanity/PortableText"
import {urlFor} from "../sanity/imageUrl"
import { LoadingSpinner } from "../UI/LoadingSpinner"

export const ArticleSchule = () => {
    const {data, loading} = useArticle('biodanzaschule')
    const heroUrl = data?.heroImage ? urlFor(data.heroImage) : null

    if (loading) {
        return (
            <div className="d-flex center">
                <div className="article-container d-flex center">
                    <LoadingSpinner label="Lädt…" />
                </div>
            </div>
        )
    }

    return (
        <div className="d-flex center">

            <div  className="article-container d-flex center">
                <div className="article-header d-flex center">
                    <img src={heroUrl || Logo} alt="Logo" className="article-logo"/>
                </div>

                <div className="title-with-image-container">
                    <h2 className="title">
                        <span className="image-text">{data?.title || 'Biodanza Schule Freiburg'}</span>
                    </h2>
                </div>

                <div className="article-content center">
                    {data?.excerpt ? (
                        <PT value={data.excerpt} />
                    ) : (
                        <p>
                            Die Biodanza Schule Freiburg lebt eine Willkommenskultur und ist Mitglied der Internationalen
                            Biodanza Federation.
                            <br/> <br/>
                            Wir arbeiten nach den internationalen Ausbildungsrichtlinien der IBFed und machen uns zum Ziel,
                            Schüler:innen individuel in ihren Entwicklungsprozessen bis hin zur Ausübung des Berufes als
                            Biodanzalehrer:in zu begleiten. Mit der Ausbildung erwirbst Du eine berufliche, international
                            anerkannte Qualifikation.
                        </p>
                    )}

                    <ReadMoreButton link={"/biodanzaschuleFreibung"}/>

                </div>



            </div>
        </div>
    );
};


